<template>
  <b-row>
    <b-col cols="12">
      <TableComponents
        v-if="!showForm"
        :columns="columns"
        :rows="listaGrupos"
        title-table="Grupo"
        module="grupoSettingsModule"
        sort-name="descricao"
        :add-permission="'ROLE_GRUPO_PROCEDIMENTO_INSERIR'"
        :view-permission="'ROLE_GRUPO_PROCEDIMENTO_CONSULTAR'"
        :edit-permission="'ROLE_GRUPO_PROCEDIMENTO_ATUALIZAR'"
        :delete-permission="'ROLE_GRUPO_PROCEDIMENTO_DELETAR'"
        @add="addNew"
        @edit="edit"
      />
      <FormGrupo
        v-else
        @cancelar="cancelar"
      />
    </b-col>
  </b-row>
</template>
<script>
import { mapState } from 'vuex'
import TableComponents from '@/layouts/components/TableComponents.vue'
import { BRow, BCol } from 'bootstrap-vue'
import mixinsGlobal from '@/mixins'
import FormGrupo from './forms/FormGrupo.vue'

export default {
  components: {
    BRow,
    BCol,
    TableComponents,
    FormGrupo,
  },
  mixins: [mixinsGlobal],
  computed: {
    ...mapState('grupoSettingsModule', {
      listaGrupos: state => state.listaGrupos,
    }),
  },
  data() {
    return {
      showForm: false,
      columns: [
        {
          label: 'Id',
          field: 'id',
        },
        {
          label: 'Nome',
          field: 'descricao',
        },
        {
          label: 'Ativo',
          field: 'ativo',
        },
        {
          label: 'Action',
          field: 'action',
        },
      ],
    }
  },
  methods: {
    addNew() {
      this.$store.dispatch('grupoSettingsModule/reset')
      this.showForm = true
    },
    edit(data) {
      this.$store.dispatch('grupoSettingsModule/prepareToEdit', data)
      this.showForm = true
    },
    cancelar() {
      this.showForm = false
    },
  },
}
</script>
